import type { Ref } from 'vue'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { noFilterCountersQueryKey } from '@autobid/ui/composables/car/data/useNoFilterCounters'
import { NO_FILTER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useNoFilterCountersSocket'
import { randomDebounce } from '@autobid/ui/utils/randomDebounce'
import { useQueryClient } from '@tanstack/vue-query'

export function useNoFilterItemPublish() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const itemPublishDebounce = useState(
    'no-filter-item-publish-debounce',
    () => ({}),
  ) as Ref<Record<number, NodeJS.Timeout>>

  const itemPublish = () => {
    startListen({
      eventName: 'premium.ITEM_PUBLISH',
      callbackName: NO_FILTER_SOCKET_CALLBACK,
      callback: (event) => {
        clearTimeout(itemPublishDebounce.value[event.context.auctionId])
        itemPublishDebounce.value[event.context.auctionId] = randomDebounce(
          1000,
          3000,
          () => {
            const queryKey = noFilterCountersQueryKey.byAuctionId(event.context.auctionId)
            queryClient.invalidateQueries(queryKey)
          },
        )
      },
    })
  }

  return { itemPublish }
}
